import IQueries from "@/interfaces/IQueries";

// Path with parameters
const premium: IQueries = {
  issue_premium: {
    path: "/vpn/rad_user_make_prem_requests",
    method: "POST",
  },
};

export default premium;
